<!--
 * @Author: Belief liang.huang@rockynet.onaliyun.com
 * @Date: 2025-11-04 16:55:53
 * @LastEditors: hl
 * @LastEditTime: 2026-03-26 15:00:00
 * @FilePath: /mall-wap-vue/src/views/mine/question/detail/components/Notification.vue
-->
<template>
  <div class="question">
    <div class="item">尊敬的客户：</div>
    <div class="item">您好！</div>
    <div class="item">
      {{
        $G(
          "为帮助您更好地选购Myaz.com境外商品，请您在购买前务必认真、详细阅读并完全理解本告知书的全部内容，并对自身风险承担做出客观判断。同意本告知书内容后再下单购买："
        )
      }}
    </div>
    <div class="item">
      1.<span class="item_title">
        您在本（公司）网站购买的境外商品等同于原产地直接销售商品，因此商品本身可能无中文标签，如果需要您可以通过网站查看相关商品中文电子标签或联系客服。</span
      >
    </div>
    <div class="item">
      2.
      您购买的境外商品符合原产地有关质量、安全、卫生、环保、健康、标识的相关标准，与我国产品标准或有所不同，您须明确知悉并承诺承担由此可能造成的危害、损失或者其他风险，本（公司）网站不承担责任。
    </div>
    <div class="item">
      3.
      您在本（公司）网站购买的境外商品必须为您本人自用，不得作为商用或者转售，违背者自负法律责任。
    </div>
    <template v-if="$appSource === 3">
      <div class="item">
        4.
        {{
          $G(
            "Myaz.com声明，所售商品由Myaz.com提供，商品品质均符合原产地相关标准，由Myaz.com承担商品质量安全保证责任。"
          )
        }}
      </div>
      <div class="item">
        5.
        您在本（公司）网站购买的境外商品时，自动视为由本（公司）网站为您向相关部门申报和代缴税款。
        Myaz.com精选全球好货，为您提供100%正品。
      </div>
      <div class="item item_top">
        {{ $G("Myaz.com精选全球好货，为您提供100%正品。") }}
      </div>
      <div class="item">谢谢！</div>
      <div class="item">{{ $G("全球购") }}</div>
    </template>
    <template v-else>
      <div class="item">
        4.
        {{
          $G(
            "妙客云声明，所售商品由妙客云提供，商品品质均符合原产地相关标准，由妙客云承担商品质量安全保证责任。"
          )
        }}
      </div>
      <div class="item">
        5.
        您在本（公司）网站购买的境外商品时，自动视为由本（公司）网站为您向相关部门申报和代缴税款。
        妙客云精选全球好货，为您提供100%正品。
      </div>
      <div class="item item_top">
        {{ $G("Myaz.com精选全球好货，为您提供100%正品。") }}
      </div>
      <div class="item">谢谢！</div>
      <div class="item">{{ $G("az全球购") }}</div>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    backClick() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
  padding: 15px;
  border-top: 1px solid #eee;
}
.item {
  padding-top: 10px;
}
.item_index {
  text-indent: 25px;
}
.item_title {
  font-size: 14px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
}
.item_top {
  margin-top: 30px;
}
.go {
  color: #2976e8;
}
</style>
